<template>
  <transition name="link-fade">
    <div class="has-text-centered top-link"
         @click="goToTop"
         v-if="showTopLink"
         transition="link-fade">
      <div><span class="material-icons">vertical_align_top</span></div>
      <div>Top</div>
    </div>
  </transition>
</template>

<style lang='scss'>
@import "@/assets/vars.scss";
.link-fade-enter-active, .link-fade-leave-active {
  transition: opacity .5s;
}
.link-fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.top-link:hover{
  opacity: 1;
}

.top-link {
  transition-property: opacity;
  position: fixed;
  opacity: 0.7;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  background-color: $eggshell;
  color: $dark;
  padding: 10px 20px; /* Some padding */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer;
}
</style>

<script>
export default {
  name: 'TopLink',
  props: {
    showY: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      showTopLink: false,
    };
  },
  methods: {
    goToTop() {
      window.scrollTo(0, 0);
    },
    handleScroll() {
      this.showTopLink = (this.getWindowOffset() > this.showY);
    },
    getWindowOffset() {
      if (window.pageYOffset !== undefined) {
        return window.pageYOffset;
      }
      return (document.documentElement
        || document.body.parentNode
        || document.body).scrollTop;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
